import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '@/components/base/Button';

export default function NotFound() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center px-6 text-center">
      {/* Logo */}
      <div className="w-16 h-16 flex items-center justify-center mb-6">
        <img
          src="https://storage.readdy-site.link/project_files/56cd5c38-7b0a-4a14-b4db-95b4319f943c/bf902dd9-b2ed-4d83-8680-96eb5154116a_compressed_XL_Logo.webp"
          alt="Xceptional Learning"
          className="w-14 h-14 object-contain opacity-50"
        />
      </div>

      <div className="font-heading font-700 text-8xl text-background-200 mb-4 select-none">404</div>
      <h1 className="font-heading font-700 text-foreground-900 text-2xl mb-2">{t('notFound.title')}</h1>
      <p className="text-foreground-500 text-sm font-label mb-8 max-w-sm">
        {t('notFound.description')}
      </p>

      <div className="flex items-center gap-3">
        <Button variant="primary" iconLeft="ri-arrow-left-line" onClick={() => navigate(-1)}>
          {t('notFound.goBack')}
        </Button>
        <Button variant="outline" iconLeft="ri-home-4-line" onClick={() => navigate('/login')}>
          {t('notFound.home')}
        </Button>
      </div>
    </div>
  );
}